module.exports = __webpack_public_path__ + "a201b29baca7d194f81942a430f05898.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/booking.svg
// module id = 2651
// module chunks = 0